module.exports = __webpack_public_path__ + "img/column1-pixel.9a7a4d6f.png";